import { FiscalProfileOutput } from '../doctor-model';

export interface DoctorFiscalIdRequestModel {
  first_name: string | null;
  last_name: string | null;
  codice_fiscale: string | null;
}

export const FISCAL_PROFILE_FIELDS: (keyof FiscalProfileOutput)[] = [
  'first_name',
  'last_name',
  'certified_email',
  'codice_univoco',
  'regime_fiscale',
  'specializzazione',
  'iban',
  'bank_name',
  'iban_2',
  'bank_name_2',
  'fiscal_address',
  'fiscal_street_number',
  'fiscal_city',
  'fiscal_province',
  'fiscal_zip_code',
];

export interface StsProfileUpdateInput {
  sts_username?: string | null;
  sts_password?: string | null;
  sts_pin?: string | null;
}

export interface StsProfileCreateInput {
  sts_username: string;
  sts_password: string;
  sts_pin: string;
}

export interface StsProfileOutput {
  configured: boolean;
  sts_username: string | null;
}

export interface StsProfileOperationOutput {
  detail: string;
}
